import isPushSupported from './isPushSupported';
import urlB64ToUint8Array from './urlB64ToUint8Array';
import derivePublicVapidKey from './derivePublicVapidKey';
import getCurrentHostname from '../../utils/getCurrentHostname';
import localStore from '../storage/localStore';
import { LOCAL_STORAGE_CLIENT_UUID_KEY } from '../../config/constants';

const saveOptIn = async (): Promise<void> => {
  if (!isPushSupported()) {
    throw new Error('Push notifications not supported');
  }

  const vapidKey = derivePublicVapidKey();

  if (!vapidKey) {
    throw new Error('Public VAPID key not found');
  }

  try {
    const serviceWorker = await navigator.serviceWorker.ready;
    const clientUuid = await localStore.getItem<string>(LOCAL_STORAGE_CLIENT_UUID_KEY);
    const deriveParams = window.location.href.match(/\/v3(?:\/(pr-\d+))?(?:\/events\/([^/]+))/);
    const prNumber = deriveParams?.[1];
    const eventUniqueCode = deriveParams?.[2];

    const hostname = getCurrentHostname();

    const optIn = await serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(vapidKey),
    });

    // Register the opt-in
    if (clientUuid) {
      await fetch(`${hostname}/v2/api/push/opt-in`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'client-uuid': clientUuid,
        },
        body: JSON.stringify({ optIn }),
      });

      const welcomeNotification: { title: string; contents: NotificationOptions } = {
        title: "Great! You're subscribed!",
        contents: {
          icon: `${hostname}/v3/pwa-64x64.png`,
          body: 'Stay tuned for updates from the participants you follow.',
        },
      };

      if (eventUniqueCode) {
        welcomeNotification.contents.data = {
          callToActionUrl: `${hostname}/v3/${prNumber ? `${prNumber}/` : ''}events/${eventUniqueCode}/following`,
        };
      }

      serviceWorker.showNotification(welcomeNotification.title, welcomeNotification.contents);
    }

    return;
  } catch (error) {
    console.error('Push Notification subscription error: ', error);
    throw error;
  }
};

export default saveOptIn;
